import { type FC, useCallback } from 'react';
import { graphql, useFragment } from 'react-relay';
import classnames from 'classnames';
import FacebookIcon from 'dibs-icons/exports/legacy/Facebook';
import { useIntl, defineMessages } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

// helpers
import { trackFacebookClick } from '../../tracking/iconBubblesTracking';
import { facebookShare } from 'dibs-social-sharing/exports/shareActions';

import { type SocialShareVariant } from './types';
import { type PdpSharedSocialShareFacebook_item$key } from './__generated__/PdpSharedSocialShareFacebook_item.graphql';

// styles
import styles from './PdpSharedSocialShare.scss';

const messages = defineMessages({
    label: {
        id: 'PdpSharedSocialShareFacebook.label',
        defaultMessage: 'Share {title} on Facebook',
    },
});

const itemFragmnet = graphql`
    fragment PdpSharedSocialShareFacebook_item on Item {
        title
    }
`;

export const PdpSharedSocialShareFacebook: FC<
    {
        item: PdpSharedSocialShareFacebook_item$key;
    } & SocialShareVariant
> = ({ item: itemRef, variant = 'iconBubble', label }) => {
    const item = useFragment(itemFragmnet, itemRef);
    const intl = useIntl();

    const className = classnames(styles[`${variant}Variant`], styles.facebook);
    const onClick = useCallback(() => {
        trackFacebookClick(item.title);
        facebookShare({ newBrowserWindow: true });
    }, [item]);

    return (
        <Link
            ariaLabel={intl.formatMessage(messages.label, { title: item?.title })}
            className={className}
            onClick={onClick}
            role="menuitem"
            dataTn="pdp-shared-icon-facebook"
        >
            <FacebookIcon className={styles.icon} />
            {label && <span>{label}</span>}
        </Link>
    );
};
